import React, { FC, useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../store/types'
import { NxSvg } from '../../../components/svg'
import {
  Banner,
  Greetings,
  GreetingsSubtitle,
  GreetingsTitle,
} from './styles/GreetingsBanner.styles'

const GreetingsBanner: FC = (): React.ReactElement => {
  const user = useSelector((state: RootState) => state.auth.user)

  const getUserName = useCallback((): string | undefined => {
    if (user.info === null) return undefined

    const name: string = user.info.name
    const firstName: string = name.trim().split(' ')[0]

    if (firstName === '') return undefined

    return firstName.charAt(0).toUpperCase() + firstName.slice(1)
  }, [user.info])

  const greetingsTitle = useMemo((): React.ReactElement => {
    const userName: string | undefined = getUserName()

    if (!userName) return <GreetingsTitle data-testid='greetings-title'>Olá!</GreetingsTitle>

    return (
      <GreetingsTitle data-testid='greetings-title'>
        Olá, <span data-clarity-mask='True'>{userName}</span>!
      </GreetingsTitle>
    )
  }, [getUserName])

  return (
    <Banner>
      <Greetings>
        {greetingsTitle}
        <GreetingsSubtitle>
          Essa é a TP Digital Nexway! Confira as novas funcionalidades para o seu negócio.
        </GreetingsSubtitle>
      </Greetings>
      <NxSvg name='Connext' title='Logotipo alternativo da Nexway' />
    </Banner>
  )
}

export default GreetingsBanner
